import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config';

const TermsBadge = ({ className = '' }) => {
    const [showModal, setShowModal] = useState(false);
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleOpen = async (e) => {
        e.stopPropagation(); // Prevent card click
        setShowModal(true);
        if (!content) {
            setLoading(true);
            try {
                const res = await fetch(`${API_BASE_URL}/api/policies/terms`);
                if (res.ok) {
                    const data = await res.json();
                    setContent(data.content);
                }
            } catch (err) {
                console.error('Failed to fetch terms', err);
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <>
            {/* Badge Icon */}
            <div
                onClick={handleOpen}
                className={`absolute top-3 right-3 z-40 cursor-pointer group ${className}`}
                title="Kullanım Koşulları"
            >
                <div className="w-8 h-8 flex items-center justify-center bg-white/90 dark:bg-black/60 backdrop-blur-sm rounded-full shadow-sm border border-slate-200 dark:border-white/10 transition-transform hover:scale-110 group-hover:bg-primary group-hover:text-white group-hover:border-primary">
                    <span className="material-symbols-outlined text-[18px] text-slate-500 dark:text-slate-300 group-hover:text-white filled-icon">
                        info
                    </span>
                </div>
            </div>

            {/* Modal */}
            {showModal && (
                <div
                    className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
                    onClick={(e) => { e.stopPropagation(); setShowModal(false); }}
                >
                    <div
                        className="bg-white dark:bg-[#1a1a1a] border border-gray-200 dark:border-gray-800 w-full max-w-lg rounded-xl shadow-2xl flex flex-col max-h-[85vh] relative animate-fade-in"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Header */}
                        <div className="flex items-center justify-between p-5 border-b border-gray-200 dark:border-gray-800">
                            <h3 className="text-lg font-bold text-gray-900 dark:text-white flex items-center gap-2">
                                <span className="material-symbols-outlined text-primary">gavel</span>
                                Kullanım Koşulları
                            </h3>
                            <button
                                className="w-8 h-8 flex items-center justify-center cursor-pointer text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white rounded-full hover:bg-gray-100 dark:hover:bg-white/5 transition-colors"
                                onClick={() => setShowModal(false)}
                            >
                                <span className="material-symbols-outlined text-[20px]">close</span>
                            </button>
                        </div>

                        {/* Content */}
                        <div className="bbtv-rich-text p-6 overflow-y-auto overflow-x-hidden custom-scrollbar flex-1 text-gray-700 dark:text-white/80 text-sm leading-relaxed">
                            {loading ? (
                                <div className="flex items-center justify-center py-12">
                                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                                </div>
                            ) : content ? (
                                <div dangerouslySetInnerHTML={{ __html: content }} className="bbtv-rich-text prose dark:prose-invert w-full max-w-full overflow-x-hidden break-words whitespace-normal text-justify font-serif" />
                            ) : (
                                <div className="text-center py-8 text-slate-500">
                                    İçerik yüklenemedi veya bulunamadı.
                                </div>
                            )}
                        </div>

                        {/* Footer */}
                        <div className="p-5 border-t border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-[#201010]/50 rounded-b-xl flex justify-end">
                            <button
                                className="px-6 py-2 rounded-lg bg-primary text-white hover:bg-primary-dark cursor-pointer text-sm font-bold shadow-lg shadow-primary/20 transition-colors"
                                onClick={() => setShowModal(false)}
                            >
                                Anlaşıldı
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default TermsBadge;
